var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"slide"}},[(_vm.show)?_c('div',{staticClass:"position-fixed alert w-100 text-center m-0 text-white",class:{
            [`bg-${_vm.theme}`]: `bg-${_vm.theme}`,
            [`alert-${_vm.position}`]: `alert-${_vm.position}`,
        }},[_vm._v(" "+_vm._s(_vm.message)+" ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }